export const config = {
  modelName: 'faqPage',
} as const;
